import { ROUTES } from '@/constants'

export const redirectToLogin = () => {
  window.location.href = ROUTES.LOGIN
}
